<template>
	<div>
    <div class="d-flex align-center mb-4 pa-4">
      <v-avatar size="72" color="primary" class="mr-4">
        <v-img v-if="business.logo_url" :src="business.logo_url" :alt="business.name" />
        <span v-else class="white--text text-h6">{{ (business.name || '').substring(0, 2).toUpperCase() }}</span>
      </v-avatar>
      <div>
        <v-btn small outlined color="primary" :disabled="!business.logo_url" @click="downloadLogo">
          <v-icon left small>mdi-download</v-icon>
          Télécharger le logo
        </v-btn>
        <div v-if="!business.logo_url" class="text-caption text--secondary mt-1">Aucun logo</div>
      </div>
    </div>
	<v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr
          v-for="item in profile"
          :key="item.name"
        >
          <th>{{ item.label }}</th>
          <td class="text-right">{{ item.name }}</td>
        </tr>
        <tr>
          <th>ACTIONS</th>
          <td class="text-right">
            <v-icon
        small
        class="edit_button"
        @click="edit(business)"
      >
        mdi-pencil
      </v-icon>
          </td>
        </tr>
      </tbody>
      <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card class="modern-card">
        <v-card-title class="dialog-title">
          <v-icon left color="primary">mdi-domain</v-icon>
          {{ form_title }}
        </v-card-title>
        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Nom Entreprise *"
                required
                v-model=account.name
                outlined
                dense
                prepend-inner-icon="mdi-office-building"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Téléphone Entreprise *"
                required
                v-model=account.phone
                outlined
                dense
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="E-mail *"
                required
                v-model=account.email
                outlined
                dense
                prepend-inner-icon="mdi-email"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Adresse Entreprise"
                required
                v-model=account.address
                outlined
                dense
                prepend-inner-icon="mdi-map-marker"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Nom Contact"
                required
                v-model=account.contact_full_name
                outlined
                dense
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Téléphone"
                required
                v-model=account.contact_phone
                outlined
                dense
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="E-mail Contact"
                required
                v-model=account.contact_email
                outlined
                dense
                prepend-inner-icon="mdi-email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Numéro d'Identification"
                required
                v-model=account.contact_id
                outlined
                dense
                prepend-inner-icon="mdi-card-account-details"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                :items="id_types"
                item-value=name
                item-text=name
                label="Type d'Identification *"
                required
                v-model=account.contact_id_type
                outlined
                dense
                prepend-inner-icon="mdi-card-bulleted"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Préfixe (Sous-domaine) *"
                required
                v-model=account.prefix
                outlined
                dense
                prepend-inner-icon="mdi-web"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="close" class="cancel-btn">Annuler</v-btn>
          <v-btn
            color="secondary"
            @click="save"
            :loading="loading"
            :disabled="loading"
            class="save-btn"
          >
            <v-icon left small>mdi-check</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
  </v-simple-table>
  </div>
</template>

<script>
import { logoFileName, saveBlob } from '../../utils/logoDownload'

export default {
  name: 'ProfileView',
  props: {
    profile: {},
    business: []
  },
  methods: {
    async downloadLogo() {
      try {
        var r = await this.$axios.get('/businesses/' + this.business.id + '/logo/download', { responseType: 'blob' })
        saveBlob(r.data, logoFileName(this.business))
      } catch (e) {
        alert('Téléchargement impossible. Réessayez ou vérifiez votre session.')
      }
    },
    save: function(){
      var self = this;
      if(this.validateData()){
        this.loading = true
        var url = '/businesses/'+this.account.id
        var payload = Object.assign({}, self.account)
        delete payload.uid
        this.$axios.put(url+"?data="+encodeURIComponent(JSON.stringify(payload)))
          .then(response => {
            self.business = response.data
            self.profile = [
            {label: "NOM ENTREPRISE", name: response.data.name, key:"name"},
            {label: "TELEPHONE", name: response.data.phone, key:"phone"},
            {label: "E-MAIL", name: response.data.email, key:"email"},
            {label: "ADRESSE", name: response.data.address, key:"address"},
            {label: "NOM CONTACT", name: response.data.contact_full_name, key:"contact_full_name"},
            {label: "TELEPHONE CONTACT", name: response.data.contact_phone, key:"contact_phone"},
            {label: "E-MAIL CONTACT", name: response.data.contact_email, key:"contact_email"},
            {label: "IDENTIFICATION", name: response.data.contact_id, key:"contact_id"},
            {label: "TYPE IDENTIFICATION", name: response.data.contact_id_type, key:"contact_id_type"},
            {label: "SOUS-DOMAINE", name: response.data.prefix, key:"prefix"},
            {label: "UID", name: response.data.uid || '--', key:"uid"}
            ]
            self.dialog = false
            self.loading = false
            self.reset()
          })
        }
      },
      validateData: function(){
        if(!/^[a-z0-9]*$/.test(this.account.prefix)){
          alert("Le préfix ne peut contenir que des chiffres et des lettres minuscules")
          return false
        }
        if(this.account.name == ""){
          alert("Vous devez un nom pour le compte")
          return false  
        }

        if(this.account.address == ""){
          alert("Vous devez indiquer une adresse")
          return false
        }

        if(this.account.prefix == ""){
          alert("Vous devez choisir un prefix. Seuls les lettres et les chiffres sont autorisés.")
          return false
        }

        if(this.account.phone == ""){
          alert("Vous devez choisir un téléphone")
          return false
        }

        if(this.account.email == ""){
          alert("Vous devez choisir un email")
          return false
        }

        if(this.account.contact_full_name == ""){
          alert("Vous devez indiquer un nom pour la personne de contact")
          return false
        }

        if(this.account.contact_phone == ""){
          alert("Vous devez indiquer un téléphone pour la personne de contact")
          return false
        }

        if(this.account.contact_email == ""){
          alert("Vous devez indiquer un email pour la personne de contact")
          return false
        }

        if(this.account.contact_id == ""){
          alert("Vous devez indiquer un numéro d'identité pour la personne de contact")
          return false
        }
        return true;
      },
      edit: function(item){
        this.account = Object.assign({}, item)
        this.form_title = "Editer Compte : "+this.account.name
        this.dialog = true
      },
      close: function(){
        this.dialog = false
        this.loading = false
      }
  },
  data () {
      return {
        loading: false,
        id_types: [{name:'CIN'}, {name:'NIF'}, {name:'PASSPORT_NUMBER'}, {name:'DRIVER_LICENSE'}],
        dialog:'',
        form_title: '',
        account: {
          name: '', 
          address: '', 
          prefix:'',
          phone: '', 
          email: '', 
          contact_full_name: '', 
          contact_phone: '', 
          contact_email: '',
          contact_id:'',
          contact_id_type:"CIN"
        }
    }
  }
}
</script>
